export default {
    fetchRecords(body) {
        return new Promise((resolve, reject) => {
            http.post('api/document-templates/list', {
                page: body.page,
                search: body.search,
                length: body.pageLength,
                order: [{'column': body.orderColumn, 'dir': body.orderAsc ? 'asc' : 'desc'}],
                filter: body.filter
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getAll(style) {
        return new Promise((resolve, reject) => {
            http.get('api/document-templates' + (style ? '?style=' + style : '')).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getAllActive(style) {
        return new Promise((resolve, reject) => {
            http.get('api/document-templates/active' + (style ? '?style=' + style : '')).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getAllCategorized(style) {
        return new Promise((resolve, reject) => {
            http.get('api/document-templates/grouped-by-categories' + (style ? '?style=' + style : '')).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    generate(documentTemplateId, data) {
        return new Promise((resolve, reject) => {
            http.post('api/document-templates/' + documentTemplateId + '/generate', data).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    generateTemplates(data) {
        return new Promise((resolve, reject) => {
            http.post('api/document-templates/documents/generate', data).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getDocumentTemplate(id, style = null) {
        return new Promise((resolve, reject) => {
            http.get('api/document-templates/' + id + (style ? '?style=' + style : '')).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    saveDocumentTemplate(data, id = null) {
        return new Promise((resolve, reject) => {
            http.post(`api/document-templates/${id ?? ''}`, data).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    saveDocumentTemplateHTML(documentTemplateId, html) {
        return new Promise((resolve, reject) => {
            http.post('api/document-templates/' + documentTemplateId + '/save-html', {template: html}).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    deleteDocumentTemplate(documentTemplateId) {
        return new Promise((resolve, reject) => {
            http.delete('api/document-templates/' + documentTemplateId).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    },

    removeTemplateFile(documentTemplateId) {
        return new Promise((resolve, reject) => {
            http.delete('api/document-templates/' + documentTemplateId + '/remove-template-file').then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    fetchGeneratedDocuments(documentTemplateId, body) {
        return new Promise((resolve, reject) => {
            http.post('api/document-templates/' + documentTemplateId + '/documents-list', {
                page: body.page,
                search: body.search,
                length: body.pageLength,
                order: [{'column': body.orderColumn, 'dir': body.orderAsc ? 'asc' : 'desc'}],
                filter: body.filter
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    deleteGeneratedDocument(documentId) {
        return new Promise((resolve, reject) => {
            http.delete('api/document-templates/documents/' + documentId).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getVocabulary() {
        return new Promise((resolve, reject) => {
            http.get('api/document-templates/vocabulary').then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    }
}
